import { useQuery } from '@tanstack/react-query';
import { getPublicMarketingMaterials } from '@/services/api';

/**
 * React Query hook for fetching public marketing materials catalog
 * with 5-minute stale time and refetch on window focus
 */
export function useMarketingMaterials() {
  return useQuery({
    queryKey: ['marketing-materials', 'public-catalog'],
    queryFn: getPublicMarketingMaterials,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });
}
